import { h } from "preact";
/**
 * Inject CSS in your component tree
 * Pass-in a stringifiable object as a `styles` prop to have it injected in a `<style>` tag.
 */
var WithCss = function (_a) {
    var styles = _a.styles, children = _a.children;
    var styleContent = styles ? styles.toString() : null;
    return (h("span", null,
        styleContent === null ? null : h("style", null, styleContent),
        children));
};
export default WithCss;
//# sourceMappingURL=WithCss.js.map